import { render, staticRenderFns } from "./CustomFormFieldsList.vue?vue&type=template&id=0c6692cf"
import script from "./CustomFormFieldsList.vue?vue&type=script&lang=js"
export * from "./CustomFormFieldsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports